import { render, staticRenderFns } from "./HelpdeskTickets.vue?vue&type=template&id=2f43bbb5"
import script from "./HelpdeskTickets.vue?vue&type=script&lang=js"
export * from "./HelpdeskTickets.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTickets.vue?vue&type=style&index=0&id=2f43bbb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports